import i18n from '../../../i18n';

export const deviceAvailabilityReportFields = [
    "modelCode",
    "serialNumber",
    "ip",
    "location",
    "daysCount"
];

export const deviceAvailabilityReportConfig = {
    code : 'DEVICE_AVAILABILITY',
    gridStateKey: 'gridReportDeviceAvailability',
    filter: {
        getter: 'deviceAvailabilityFilter',
        mutation: 'setDeviceAvailabilityFilter'
    },
    columns: [{
        id: 1,
        dataField : 'modelCode',
        caption : i18n.t('report.titleReports.deviceAvailability.modelCode'),
        dataType : 'string',
        sortOrder: 10
    }, {
        id: 2,
        dataField : 'serialNumber',
        caption : i18n.t('report.titleReports.deviceAvailability.serialNumber'),
        dataType : 'string',
        sortOrder: 20
    }, {
        id: 3,
        dataField : 'ip',
        caption : i18n.t('report.titleReports.deviceAvailability.ip'),
        dataType : 'string',
        sortOrder: 30
    }, {
        id: 4,
        dataField : 'location',
        caption : i18n.t('report.titleReports.deviceAvailability.location'),
        dataType : 'string',
        sortOrder: 40
    }, {
        id: 5,
        dataField : 'daysCount',
        caption : i18n.t('report.titleReports.deviceAvailability.daysCount'),
        dataType : 'number',
        sortOrder: 50
      }]
}
